import React, {Component} from 'react';
import Styles from './style.css';
import {BeatLoader} from 'react-spinners';
import {langRegister} from "../../services/langRegister";
import {cartRegister} from "../../services/cartRegister"
import {imagesRegister} from "../../services/imagesRegister"
import {quotesRegister} from "../../services/quotesRegister"
import cx from "classnames";
import {dataRegister} from "../../services/dataRegister";
import {marketRegister} from "../../services/marketRegister";
import {userRegister} from "../../services/userRegister";
import {salesChannelRegister} from "../../services/salesChannelRegister";

class ModalKeyword extends Component {

    constructor(props) {
        super(props);
        this.state = {
            keyword: "",
            email: "",
            isLoading: false
        };
    };

    componentWillMount() {
        this.setState({keyword: this.props.initKeyword});
        this._updateUser();
    }

    _updateUser(){
        let user = userRegister.get();
        try{
            if(user.email){
                this.setState({email: user.email, inhouse: user.inhouse});
            }
        }catch (e) {}
    }

    _close(){
        this.props.setKeyword(false);
    }

    _set(){
        if(this._emailValidation(this.state.email)){
            this.setState({isLoading: true, error: false});
            let data = {email: this.state.email, name: this.state.keyword, subject: "industry request", message: salesChannelRegister.get("market")};
            dataRegister.industryRequest(salesChannelRegister.get("market"), data).then((response) => {
                this._close(true);
            }, (error) => {
                this._close(true);
                this.setState({isLoading: false});
            });
        }else{
            this.setState({error: true});
        }
    }

    _terms(){
        window.open('https://legal.'+dataRegister.domain+"/"+salesChannelRegister.get("market") + "/" + langRegister.lang() + "/terms/adbop", '_blank');
    }

    _emailValidation(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    _renderText(item) {
        return langRegister.get("modal-keyword", item);
    }

    render() {
        return (
              <div className={Styles.overlay}>
                  <div className={Styles.overlayModal}>
                      <div className={Styles.overlayModalInner}>
                          <img onClick={() => this._close()}
                               className={Styles.overlayCloseButton}
                               src={require("../../assets/images/close_icon.svg")}/>
                          <div>
                              <div className={Styles.overlayModalText}>
                                  {this._renderText("item_1")}
                              </div>
                              <div className={Styles.overlayModalText}>
                                  <span className={Styles.overlayModalTextBold}>{this.state.keyword}</span>, <span className={Styles.overlayModalTitle}>{this._renderText("item_2")}</span>
                              </div>
                              <div className={Styles.overlayModalInputContainer}>
                                  <input disabled={this.state.inhouse}  value={this.state.email} onChange={(event) => this.setState({email: event.target.value})} placeholder={this._renderText("item_4")} className={
                                      cx(Styles.overlayModalInputContainerInput,
                                          {
                                              [Styles.overlayModalInputContainerInputError]: this.state.error && !this._emailValidation(this.state.email)
                                          })
                                  }/>
                                  <div className={
                                      cx(Styles.overlayModalInputContainerInputLine,
                                          {
                                              [Styles.overlayModalInputContainerInputLineError]: this.state.error && !this._emailValidation(this.state.email)
                                          })
                                  }/>
                              </div>
                              <div className={Styles.overlayModalTerms}>
                                  {this._renderText("item_5")}&nbsp;<span onClick={() => this._terms()} className={Styles.overlayModalTermsLink}>{this._renderText("item_6")}</span>
                              </div>
                          </div>
                      </div>
                      <div className={Styles.overlayModalButtons}>
                          <div className={Styles.overlayModalButtonsItem}>
                              <div onClick={() => {this._set()}} className={cx([Styles.overlayModalButtonsItemButton, Styles.buttonActive])}>
                                  {
                                      this.state.isLoading &&
                                      <BeatLoader size={9} color={'#ffffff'} loading={true}/>
                                  }
                                  {
                                      !this.state.isLoading &&
                                      this._renderText("item_3")
                                  }
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
        );
    }
}

export default ModalKeyword;


// WEBPACK FOOTER //
// ./src/components/modal-keyword/component.js